import { STATES } from '../../../../constants';

export function ShareMovePublicConfig($stateProvider) {
  'ngInject';
  $stateProvider.state(STATES.PUBLIC_SHARE, {
    url: '/share/{shareCode}',
    views: {
      '@': {
        template: '<upd-share-move-public></upd-share-move-public>',
      },
    },
    disableBreadcrumb: true,
    hideHeader: true,
    hideFooter: true,
    scrollTop: true,
    analytics: {
      page: 'Public Moving Announcement',
    },
    data: {
      permissions: 'anyone',
    },
  });
}
